export default {"src":"/_next/static/media/creator_type.8309e155.svg","height":80,"width":82,"blurWidth":0,"blurHeight":0};